/**
 * @author Rohman Widiyanto
 * @email rohmansca@gmail.com
 * @create date 2022-04-21 00:13:24
 * @modify date 2022-04-21 00:13:24
 */

import React from 'react'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { Box, Typography, Button } from '@mui/material'

import { useStores } from 'models'
import { centered } from 'assets'
import { ModalWrapper } from 'components'
import { somethingWrong } from 'assets/images'

export const ServerError: React.FC = observer(() => {
  const { t } = useTranslation()
  const { modalStore: { serverError, setValue: setModalValue }} = useStores()

  return (
    <ModalWrapper
      open={serverError}
      onClose={() => setModalValue('serverError', false)}
      containerProps={{
        sx: {
          minWidth: '100%',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column'
        }
      }}
    >
      <Box sx={{...centered, flexDirection: 'column', flex: 1}} onClick={() => setModalValue('serverError', false)}>
        <img src={somethingWrong} alt='not-found' style={{maxWidth: '100%'}} />
        <Typography variant='h5' sx={{mt: 3}}>
          {t('modal.somethingWrongDescription')}
        </Typography>
        <Button
          variant='contained'
          className='wide'
          onClick={() => setModalValue('serverError', false)}
          sx={{mt: 3}}
        >
          {t('common.close')}
        </Button>
      </Box>
    </ModalWrapper>
  )
})